export const RECEIVE_FOLDERS = 'RECEIVE_FOLDERS';
export const REQUEST_FOLDERS = 'REQUEST_FOLDERS';
export const TOGGLE_FOLDER_FILTER = 'TOGGLE_FOLDER_FILTER';

